import fetchCall from "./fetch.mjs";

export const hosting = (window.location.hostname === "localhost") ? "https://beta.megacall.cl" : ""


export const llamadasEntrantes = async (
  type2,
  id,
  diaInicio,
  mesInicio,
  diaFinal,
  mesFinal,
  yearInicio,
  yearFinal,
  anexos
) => {
  let respEntrantes = await fetchCall(
    type2,
    id,
    diaInicio,
    mesInicio,
    diaFinal,
    mesFinal,
    yearInicio,
    yearFinal,
    anexos
  );
  if (respEntrantes.type === "SQL") {
    llamadasEntrantes(
      type2,
      id,
      diaInicio,
      mesInicio,
      diaFinal,
      mesFinal,
      yearInicio,
      yearFinal,
      anexos
    );
  }
  return respEntrantes;
};

export const llamadasErrores = (
  type2,
  id,
  diaInicio,
  mesInicio,
  diaFinal,
  mesFinal,
  yearInicio,
  yearFinal,
  anexos
) => {
  if (anexos.length <= 0) {
    return {
      mensaje: "Debes seleccionar al menos un anexo.",
      errorTipo: 1,
    };
  }
  if (yearFinal < yearInicio) {
    return {
      mensaje: "La combinación de fechas esta errada.",
      errorTipo: 2,
    };
  }
  if (yearInicio === yearFinal) {
    if (mesFinal < mesInicio) {
      return {
        mensaje: "La combinación de fechas esta errada.",
        errorTipo: 2,
      };
    }
    if (mesFinal === mesInicio && diaFinal < diaInicio) {
      return {
        mensaje: "la combinación de fechas esta errada.",
        errorTipo: 2,
      };
    }
  }

  return 200;
};

export const years = [2022, 2023,2024];

export const llamadasSalientes = async (
  type2,
  id,
  diaInicio,
  mesInicio,
  diaFinal,
  mesFinal,
  yearInicio,
  yearFinal,
  anexos
) => {
  let respSalientes = await fetchCall(
    type2,
    id,
    diaInicio,
    mesInicio,
    diaFinal,
    mesFinal,
    yearInicio,
    yearFinal,
    anexos
  );

  return respSalientes;
};
function filterItems(nombre, anexos) {
  if (anexos) {
    return anexos.filter(function (elNombre) {
      return elNombre.toLowerCase().indexOf(nombre.toLowerCase()) > -1;
    });
  }
}

export const mesArr = [
  "",
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export function secondsToString(seconds) {
  var hour = Math.floor(seconds / 3600);
  hour = hour < 10 ? "0" + hour : hour;
  var minute = Math.floor((seconds / 60) % 60);
  minute = minute < 10 ? "0" + minute : minute;
  var second = seconds % 60;
  second = second < 10 ? "0" + second.toFixed(0) : second.toFixed(0);
  return hour + ":" + minute + ":" + second;
}

export const sumarArreglo = (arr, condi) => {
  arr = Object.values(arr);
  let sumar = 0;
  const sumaTotal2 = arr.reduce((total, actual) => {
    //
    if (isNaN(parseFloat(actual[condi]))) {
      sumar = 0;
    } else {
      sumar = parseFloat(actual[condi]);
    }
    const devolver = parseFloat(total) + sumar;

    return devolver;
  }, 0);

  return sumaTotal2;
};

export const sumarArregloCostestadas = (arr, condi) => {
  arr = Object.values(arr);
  let sumar;
  const sumaTotal2 = arr.reduce((total, actual) => {
    if (actual["disposition"] === "ANSWERED") {
      if (isNaN(parseFloat(actual[condi]))) {
        sumar = 0;
      } else {
        sumar = parseFloat(actual[condi]);
      }
    } else {
      sumar = 0;
    }

    const devolver = parseFloat(total) + sumar;

    return devolver;
  }, 0);

  return sumaTotal2;
};

export const arreglo = (arrAnexos, anexos, arrAnexos2) => {
  if (arrAnexos2) {
    arrAnexos = Object.values(arrAnexos).concat(Object.values(arrAnexos2));
  } else if (Object.values(arrAnexos).length > 2) {
    arrAnexos = Object.values(arrAnexos);
  }

  let duration2 = [];
  let sumar = 0;
  let sumarRing = 0;
  let sumarFallidas = 1;
  let sumarCantidad = 1;
  var condiRedu = 0;
  let billsec2 = 0;
  let cost2 = 0;
  let object2;
  var nombreFiltrar;
  //
  if (arrAnexos.length > 0) {
    object2 = arrAnexos.reduce((acc, item) => {
      if (condiRedu === 0) {
        nombreFiltrar = acc.chan1.substring(4, 8);
        if (duration2[acc.chan1] === undefined) {
          sumar = 0;
          sumarRing = 0;
          sumarCantidad = 1;
          cost2 = 0;
          if (acc.disposition !== "ANSWERED") {
            sumarFallidas = 1;
          } else {
            sumarFallidas = 0;
          }
        } else {
          sumar = duration2[acc.chan1].duration;
          sumarRing = duration2[acc.chan1].ring;
          billsec2 = duration2[acc.chan1].billsec;

          cost2 = duration2[acc.chan1].cost;
          if (acc.cost === null) {
            acc.cost = 0;
          }
          if (isNaN(cost2)) {
            cost2 = 0;
          }
          if (acc.disposition !== "ANSWERED") {
            sumarFallidas = parseInt(duration2[acc.chan1].fallidas) + 1;
          } else {
            sumarFallidas = parseInt(duration2[acc.chan1].fallidas) + 0;
          }

          sumarCantidad = parseInt(duration2[acc.chan1].cantidad) + 1;
        }

        let nombreFiltrar2 = filterItems(nombreFiltrar, anexos);

        duration2[acc.chan1] = {
          name: nombreFiltrar2,
          chan1: acc.chan1,
          duration: parseFloat(acc.duration) + parseFloat(sumar),
          ring: parseFloat(acc.ringtime) + parseFloat(sumarRing),
          fallidas: sumarFallidas,
          cantidad: sumarCantidad,
          billsec: parseInt(acc.billsec) + parseInt(billsec2),
          cost: parseFloat(acc.cost) + parseFloat(cost2),
          pent: acc.pent,
        };
        condiRedu = 1;
      }

      nombreFiltrar = item.chan1.substring(4, 8);
      if (duration2[item.chan1] === undefined) {
        sumar = 0;
        sumarRing = 0;
        sumarCantidad = 1;
        cost2 = 0;
        if (item.disposition !== "ANSWERED") {
          sumarFallidas = 1;
        } else {
          sumarFallidas = 0;
        }
      } else {
        sumar = duration2[item.chan1].duration;
        sumarRing = duration2[item.chan1].ring;
        billsec2 = duration2[item.chan1].billsec;

        cost2 = duration2[item.chan1].cost;
        if (item.cost === null) {
          item.cost = 0;
        }
        if (isNaN(cost2)) {
          cost2 = 0;
        }
        if (item.disposition !== "ANSWERED") {
          sumarFallidas = parseInt(duration2[item.chan1].fallidas) + 1;
        } else {
          sumarFallidas = parseInt(duration2[item.chan1].fallidas) + 0;
        }

        sumarCantidad = parseInt(duration2[item.chan1].cantidad) + 1;
      }

      nombreFiltrar = filterItems(nombreFiltrar, anexos);

      duration2[item.chan1] = {
        name: nombreFiltrar,
        chan1: item.chan1,
        duration: parseFloat(item.duration) + parseFloat(sumar),
        ring: parseFloat(item.ringtime) + parseFloat(sumarRing),
        fallidas: sumarFallidas,
        cantidad: sumarCantidad,
        billsec: parseInt(item.billsec) + parseInt(billsec2),
        cost: parseFloat(item.cost) + parseFloat(cost2),
        pent: item.pent,
      };

      return duration2;
    });

    return Object.values(object2);
  } else {
    if (Object.values(arrAnexos).length >= 1) {
      if (arrAnexos[0].disposition !== "ANSWERED") {
        sumarFallidas = 1;
      } else {
        sumarFallidas = 0;
      }
      let duration2 = [];
      nombreFiltrar = arrAnexos[0].chan1.substring(4, 8);
      nombreFiltrar = filterItems(nombreFiltrar, anexos);
      duration2[arrAnexos.chan1] = {
        name: nombreFiltrar,
        chan1: arrAnexos[0].chan1,
        duration: isNaN(parseFloat(arrAnexos[0].duration))
          ? 0
          : parseFloat(arrAnexos[0].duration),
        ring: isNaN(parseFloat(arrAnexos[0].ringtime))
          ? 0
          : parseFloat(arrAnexos[0].ringtime),
        fallidas: sumarFallidas,
        cantidad: Object.values(arrAnexos).length,
        billsec: isNaN(parseFloat(arrAnexos[0].billsec))
          ? 0
          : parseFloat(arrAnexos[0].billsec),
        cost: isNaN(parseFloat(arrAnexos[0].cost))
          ? 0
          : parseFloat(arrAnexos[0].cost),
        pent: arrAnexos[0].pent,
      };
      return Object.values(duration2);
    }
    return [];
  }
};

export const audioVacio2 = () => {};

export const forMiles = (number) => {
  number = parseFloat(number);
  if (isNaN(number)) {
    number = 0;
  }
  return (
    new Intl.NumberFormat("es-CL").format(
      number
    ) || 0
  );
};

export const forMilesUf = (number) => {
  number = parseFloat(number);
  if (isNaN(number)) {
    number = 0;
  }
  return (
    new Intl.NumberFormat("es-ES", {
      maximumFractionDigits: 3,
    }).format(
      number
    ) || 0
  );
};
export const formatoMexico = (number) => {
  const exp = /(\d)(?=(\d{3})+(?!\d))/g;
  const rep = '$1.';
  return number.toString().replace(exp,rep);
}

export const forMilesCost = (number) => {
  if (isNaN(number)) {
    number = 0;
  }
  return (
    new Intl.NumberFormat("de-DE", { minimumFractionDigits: 0 }).format(
      number
    ) || 0
  );
};

export const formatter = (valor) => {
  valor = valor === "Pendiente" ? valor : "$" + forMilesCost(valor);
  return valor;
};

export const changeIp = (item) => {
  item = item.replace("/var/spool/asterisk/", "");
  return `${localStorage.getItem("ip")}/grabaciones/${item}`;
};

export const formatearFecha = (fecha) => {
  const formateador = new Intl.DateTimeFormat("es-ES", {
    dateStyle: "medium",
    timeStyle: "medium",
  });
  const fecha2 = new Date(fecha);
  const fechaFormateada = formateador.format(fecha2);
  return fechaFormateada;
};

export const formatearFechaPDF = (fecha) => {
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  };
  const formateador = new Intl.DateTimeFormat("default", options, {
    dateStyle: "medium",
    timeStyle: "medium",
  });
  const fecha2 = new Date(fecha);
  const fechaFormateada = formateador.format(fecha2);
  return fechaFormateada;
};

export const constertarTraductor = (palabra) => {
  switch (palabra) {
    case "NO ANSWER":
      return "SIN RESPUESTA";
    case "ANSWERED":
      return "CONTESTADA";
    case "BUSY":
      return "OCUPADA";
    default:
      return "SIN RESPUESTA";
  }
};

export const puntoPorComa = (valor) => {
  valor = valor.toString();
  const value = valor.replace(".", ",");
  return value;
};

export const restaFechas = (f1, f2) => {
  var aFecha1 = f1.split("/");
  var aFecha2 = f2.split("/");
  var fFecha1 = Date.UTC(aFecha1[2], aFecha1[1] - 1, aFecha1[0]);
  var fFecha2 = Date.UTC(aFecha2[2], aFecha2[1] - 1, aFecha2[0]);
  var dif = fFecha2 - fFecha1;
  var dias = Math.floor(dif / (1000 * 60 * 60 * 24));
  return dias + 1;
};

export const tags = ["Ultimo mes", "Ultimos 30 dias"];

export const mapStateToProps = (store) => ({
  token: store.userState.token,
  entrantes: store.userState.entrantes,
  salientes: store.userState.salientes,
  dateChangeInicio: store.userState.dateChangeInicio,
  dateChangeFinal: store.userState.dateChangeFinal,
  rightAnexos: store.userState.rightAnexos,
  leftAnexos: store.userState.leftAnexos,
  rightAnexos2: store.userState.rightAnexos2,
  leftAnexos2: store.userState.leftAnexos2,
  dateIn: store.userState.dateIn,
  fetchInit: store.userState.fetchInit,
  menu: store.userState.menu,
  preselect: store.userState.preselect,
  idBuscar: store.userState.idBuscar,
  loadError: store.userState.loadError,
  errorState: store.userState.errorState,
});

export const getFecha = () => {
  let fecha = new Date();
  let entrega = new Date();
  let dia = fecha.getDate();
  let mes = fecha.getMonth(); // +1 porque los meses empiezan en 0
  let year = fecha.getFullYear();
  entrega.setDate(entrega.getDate() - (dia - 1));

  return [
    [entrega.getDate(), entrega.getMonth() + 1, year],
    [dia, mes + 1, year],
  ];
};
export const getFechaRango = () => {
  let fecha = new Date();
  let entrega = new Date();
  let dia = fecha.getDate();
  let mes = fecha.getMonth(); // +1 porque los meses empiezan en 0
  let year = fecha.getFullYear();
  let yearInicio = year;
  entrega.setDate(entrega.getDate() - 30);

  if (mes === 0) {
    yearInicio = year - 1;
  }

  return [
    [entrega.getDate(), entrega.getMonth() + 1, yearInicio],
    [dia, mes + 1, year],
  ];
};

export const handleUpdateNumber = (e) => {
  if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 188 ){
   
  } else if (e.keyCode !== 8) {
    e.preventDefault();
  }
};

export const handleUpdateNumberUF = (e) => {
  if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) ){
   
  } else if (e.keyCode !== 8) {
    e.preventDefault();
  }
};

